<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    props: {
      addressId: {
        type: [Number, String],
      },
    },
    watch: {
      addressId(newValue) {
        this.$store.commit('setSelectedAddress', Number.parseInt(newValue));
        this.setAddressRole();
      }
    },
    methods: {
      setAddressRole() {
        const addresses = this.$store.state.userProjects;
        if (addresses && addresses.length > 0) {
          const currentAddress = this.addresses.find(a => a.id === Number.parseInt(this.addressId));
          if (currentAddress) {
            this.$store.commit('setSelectedAddressRole', currentAddress.role);
          }
        }
      }
    },
    computed: {
      addresses() {
        if (this.$store.state.userProjects == null) {
          return [];
        }
        return this.$store.state.userProjects;
      }
    },
    mounted() {
      this.setAddressRole();
    }
  }
</script>

<style scoped>

</style>
